"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SmsPreview.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

// A text message as the patient sees it on their phone: the frame, the
// "Text message from …" line, and bubbles. Campaigns and the team Keywords
// tab both preview texts with it.









 const SmsPhone = ({ from, isThread, className, children }) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'sms-preview--phone', isThread && 'sms-preview--phone--thread', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
    ,  from && _react2.default.createElement('div', { className: "sms-preview--from", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}},  from ) 
    ,  children 
  )
); exports.SmsPhone = SmsPhone









 const SmsBubble = ({ side = 'team', className, children, ...rest }) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'sms-preview--bubble', side === 'patient' && 'sms-preview--bubble--patient', className), ...rest, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
    ,  children 
  )
); exports.SmsBubble = SmsBubble
